var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wa-empty-state" }, [
    _c("div", { staticClass: "wa-empty-state__inner" }, [
      _c("div", { staticClass: "wa-empty-state__icon-wrapper" }, [
        _c(
          "svg",
          {
            staticClass: "wa-empty-state__laptop",
            attrs: { viewBox: "0 0 303 172" },
          },
          [
            _c(
              "defs",
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "a",
                      x1: "50%",
                      y1: "0%",
                      x2: "50%",
                      y2: "100%",
                    },
                  },
                  [
                    _c("stop", {
                      attrs: {
                        offset: "0%",
                        "stop-color": "#25D366",
                        "stop-opacity": ".15",
                      },
                    }),
                    _vm._v(" "),
                    _c("stop", {
                      attrs: {
                        offset: "100%",
                        "stop-color": "#128C7E",
                        "stop-opacity": ".05",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "1",
                y: "1",
                width: "301",
                height: "140",
                rx: "12",
                fill: "url(#a)",
                stroke: "#25D366",
                "stroke-opacity": ".3",
                "stroke-width": "1.5",
              },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "20",
                y: "20",
                width: "120",
                height: "100",
                rx: "6",
                fill: "#25D366",
                "fill-opacity": ".12",
              },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "163",
                y: "20",
                width: "120",
                height: "45",
                rx: "6",
                fill: "#128C7E",
                "fill-opacity": ".1",
              },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "163",
                y: "74",
                width: "120",
                height: "46",
                rx: "6",
                fill: "#128C7E",
                "fill-opacity": ".1",
              },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "0",
                y: "142",
                width: "303",
                height: "30",
                rx: "6",
                fill: "#25D366",
                "fill-opacity": ".08",
              },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "121",
                y: "150",
                width: "61",
                height: "4",
                rx: "2",
                fill: "#25D366",
                "fill-opacity": ".3",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wa-empty-state__lock-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 24 24",
                width: "28",
                height: "28",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M12 1C9.24 1 7 3.24 7 6v2H5a2 2 0 00-2 2v11a2 2 0 002 2h14a2 2 0 002-2V10a2 2 0 00-2-2h-2V6c0-2.76-2.24-5-5-5zm0 2c1.66 0 3 1.34 3 3v2H9V6c0-1.66 1.34-3 3-3zm0 10a2 2 0 110 4 2 2 0 010-4z",
                  fill: "#25D366",
                  "fill-opacity": ".7",
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "wa-empty-state__title" }, [
        _vm._v(_vm._s(_vm.$t("whatsappUi.emptyTitle"))),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "wa-empty-state__subtitle" }, [
        _vm._v(_vm._s(_vm.$t("whatsappUi.emptySubtitle"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wa-empty-state__features" }, [
        _c("div", { staticClass: "wa-empty-state__feature" }, [
          _c("span", { staticClass: "wa-empty-state__feature-icon" }, [
            _vm._v("💬"),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("whatsappUi.featureChannels")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wa-empty-state__feature" }, [
          _c("span", { staticClass: "wa-empty-state__feature-icon" }, [
            _vm._v("📋"),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("whatsappUi.featureTemplates")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wa-empty-state__feature" }, [
          _c("span", { staticClass: "wa-empty-state__feature-icon" }, [
            _vm._v("🔔"),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("whatsappUi.featureRealtime")))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wa-empty-state__encryption" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 24 24",
              width: "14",
              height: "14",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M12 1C9.24 1 7 3.24 7 6v2H5a2 2 0 00-2 2v11a2 2 0 002 2h14a2 2 0 002-2V10a2 2 0 00-2-2h-2V6c0-2.76-2.24-5-5-5z",
                fill: "#667781",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("whatsappUi.encryptionFooter")))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }